import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { CampaignBundleHistoryModel } from '../models/CampaignBundleModel'

export class GetCampaignHistory extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/campaignBundle/listHistoryById',
      requesterInfo,
    })
  }

  public async historyByID(request: number): Promise<CampaignBundleHistoryModel[]> {
    return await this.postAsync<CampaignBundleHistoryModel[]>(request)
  }
}
